import React, { useState } from "react";
import { Form, Checkbox } from "antd";
import { useSelector } from "react-redux";
import Policy from "./models/modals/Policy";
import { convertToRGBAString } from "utils/helperFunctions";

//@ts-ignore
const PrivacyPolicyHolder = React.memo(({ data }) => {
  const [open, setOpen] = useState(false);
  const selectedLanguage = useSelector((state) => state.selectedLanguage);
  const errorMessages = useSelector(
    (state) => state.widgetJSON.data.general_settings.error_messages
  );
  const togglePolicyModal = () => {
    setOpen(!open);
  };
  return (
    <>
      <Policy open={open} handleClose={togglePolicyModal} data={data} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Form.Item
          name="terms"
          valuePropName="checked"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
          rules={[
            {
              required: true,
              message: errorMessages.required[selectedLanguage],
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (value === undefined || value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(errorMessages.required[selectedLanguage])
                );
              },
            }),
          ]}
        >
          <Checkbox>
            <span
              className="font-helvetica-neue-medium"
              onClick={(e) => {
                e.preventDefault();
                togglePolicyModal();
              }}
              style={{
                color: convertToRGBAString(data.policy_label_color),
                textDecoration: "underline",
                fontSize: 14,
              }}
            >
              {data.policy_label[selectedLanguage]}
            </span>
          </Checkbox>
        </Form.Item>
      </div>
    </>
  );
});

export default PrivacyPolicyHolder;
